import { useEffect, useState } from "react";
import { useSearchParams, useParams } from "react-router-dom"
import { bindLineAccount, getLINEAccessToken } from "../service/AuthService";
import type { APIResult, User } from "../my-type";
import { useNavigate } from "react-router-dom";
import { actionCreators } from "../state";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { Loader, Message, Text } from "rsuite";
import { isAllowedRiderTeamUser, RIDER_TEAM_ACCESS_DENIED_MESSAGE } from "../util/riderAccess";

//const envRedirectURI = process.env.REACT_APP_REDIRECT_URI;
//const envRedirectURI = document.location.protocol + '//' + document.location.hostname + process.env.REACT_APP_REDIRECT_URI;



export default function LineCallback() {
  let [searchParams] = useSearchParams()
  const location = searchParams.get("location")
  //const team = searchParams.get("team")
  const authCode = searchParams.get("code");
  const authState = searchParams.get("state");
  const { teamCode } = useParams();

  const dispatch = useDispatch();
  const { updateUser } = bindActionCreators(actionCreators, dispatch);
  const [message, setMessage] = useState<string>('');
  const [isShowLoading, setIsShowLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  function getCookie(cname: string) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {


    const mapingAccount = async () => {

      const envLINEClientID = process.env[`REACT_APP_LINE_CLIENT_ID_${teamCode}`];
      const envLINEClientSecret = process.env[`REACT_APP_LINE_CLIENT_SECRET_${teamCode}`];

      let params = new URLSearchParams(document.location.search);
      console.log(params)

      console.log(`team:${teamCode}`);

      if (!teamCode) {
        setMessage("登入時發生錯誤,team code not found in url");
        return;
      }

      if (!authCode) {
        setMessage(`登入時發生錯誤,no auth code found,${params}`);
        return;
      }

      // if (!envRedirectURI) {
      //   setMessage("登入時發生錯誤,no redirect uri found in env config");
      //   return;
      // }

      if (!envLINEClientID) {
        setMessage("登入時發生錯誤,no line client id found in env config");
        return;
      }

      if (!envLINEClientSecret) {
        setMessage("登入時發生錯誤,no line client secret found in env config");
        return;
      }

      //check auth_state exsits
      if (!authState) {
        setMessage("登入時發生錯誤,no auth state found");
        return;
      }

      //check auth_state is valid
      let cookieState = getCookie("oauth_state");
      console.log(`cookieState:${cookieState}`);
      if (authState !== cookieState) {
        setMessage("登入時發生錯誤,auth state not match");
        return;
      }

      // let nonce = getCookie("oauth_nonce");
      // console.log(`nonce:${nonce}`);
      // if (!nonce) {
      //   setMessage("登入時發生錯誤,nonce not found");
      //   return;
      // }

      //let redirect_uri = envRedirectURI;
      let redirect_uri = document.location.protocol + '//' + document.location.hostname + "/line/" + teamCode + "/callback";

      if (document.location.hostname === "localhost") {
        redirect_uri = `http://localhost:3000/line/${teamCode}/callback`;
      }

      if (location) {
        redirect_uri += `?location=${location}`;
      }

      console.log(`redirect_uri:${redirect_uri}`);

      //get accesstToken from LINE API
      let lineResponse = await getLINEAccessToken(authCode, encodeURI(redirect_uri), envLINEClientID!, envLINEClientSecret!);

      if (!lineResponse) {
        setMessage("登入時發生錯誤,get access token failed");
        console.log("get access token failed");
        return;
      }

      //const accessToken = liff.getAccessToken();
      const accessToken = lineResponse.access_token;
      const idToken = lineResponse.id_token;
      console.log('getAccessToken', accessToken);
      if (accessToken) {
        //alert('取得accessToken');
        //setMessage("登入中...");
        bindAccount(accessToken, idToken, teamCode, lineResponse.refresh_token, lineResponse.expires_in);
      }
    }

    mapingAccount();


  }, [])

  const bindAccount = async (accessToken: string, idToken: string, teamCode: string, refreshToken: string | null, expires_in: number) => {
    setIsShowLoading(true);
    let callResultData: APIResult = await bindLineAccount(idToken, teamCode);
    console.log(callResultData);
    setIsShowLoading(false);
    if (callResultData.statusCode === 0) {
      //alert(callResultData.message);
      //setMessage("取得LINE身份資料時發生錯誤，請重新登入LINE");
      setMessage(callResultData.message);
    } else if (callResultData.statusCode === 1) {
      //redirect to home
      //alert(callResultData);
      let user: User = callResultData.data;
      console.log(user);

      if (!isAllowedRiderTeamUser(user)) {
        updateUser(null);
        setMessage(RIDER_TEAM_ACCESS_DENIED_MESSAGE);
        return;
      }

      setMessage("登入成功");
      console.log(location);
      user.lineAccessToken = accessToken;
      user.tokenExpiry = new Date(new Date().getTime() + expires_in * 1000);
      user.refreshToken = refreshToken ? refreshToken : "";

      updateUser(user);

      if (!location) {
        navigate("/");
      } else {
        navigate(location);
      }
    } else {
      setMessage("登入時發生錯誤");
      alert(callResultData);
    }
  }


  return (<div>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    {isShowLoading && <Loader content="Line callback 登入中..." />}
    {message === RIDER_TEAM_ACCESS_DENIED_MESSAGE ? (
      <Message showIcon type="warning">
        {message}
      </Message>
    ) : (
      <Text muted>{message}</Text>
    )}
  </div>)

} 
